<template>
    <b-navbar id="template-header" class="default-layout-navbar col-lg-12 col-12 fixed-top d-flex flex-row" toggleable="lg">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center">
            <router-link class="navbar-brand brand-logo mr-4 ml-1" :to="{ name: 'dashboard' }">
                <img src="@/assets/images/watch-logo.png" alt="logo" />
                <h4 style="color:white;">Admin System</h4>
            </router-link>
            <router-link class="navbar-brand brand-logo-mini" :to="{ name: 'dashboard' }">
                <img src="@/assets/images/watch-logo.png" alt="logo" />
            </router-link>
        </div>
        <div class="navbar-menu-wrapper d-flex align-items-center justify-content-between ml-auto ml-lg-0">

            <div class="nav-search d-none d-lg-block">
                <div class="page-title">
                    <h2>{{ name }}</h2>
                </div>
            </div>
            <b-navbar-nav class="navbar-nav-right ml-auto">
                <b-nav-item-dropdown right class="preview-list mr-1 d-none">
                    <template slot="button-content">
                        <div class="nav-link count-indicator dropdown-toggle">
                            <i class="ti-email mx-0 d-none"></i>
                        </div>
                    </template>
                    <h6 class="p-3 mb-0">Messages</h6>
                    <b-dropdown-item class="preview-item">
                        <div class="preview-thumbnail">
                            <img src="https://via.placeholder.com/36X36" alt="image" class="profile-pic" />
                        </div>
                        <div class="preview-item-content flex-grow">
                            <h6 class="preview-subject ellipsis font-weight-normal">David Grey</h6>
                            <p class="font-weight-light small-text text-muted mb-0">The meeting is cancelled</p>
                        </div>
                    </b-dropdown-item>
                    <b-dropdown-item class="preview-item">
                        <div class="preview-thumbnail">
                            <img src="https://via.placeholder.com/36X36" alt="image" class="profile-pic" />
                        </div>
                        <div class="preview-item-content flex-grow">
                            <h6 class="preview-subject ellipsis font-weight-normal">Tim Cook</h6>
                            <p class="font-weight-light small-text text-muted mb-0">New product launch</p>
                        </div>
                    </b-dropdown-item>
                    <b-dropdown-item class="preview-item">
                        <div class="preview-thumbnail">
                            <img src="https://via.placeholder.com/36X36" alt="image" class="profile-pic" />
                        </div>
                        <div class="preview-item-content flex-grow">
                            <h6 class="preview-subject ellipsis font-weight-normal">Johnson</h6>
                            <p class="font-weight-light small-text text-muted mb-0">Upcoming board meeting</p>
                        </div>
                    </b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item-dropdown right class="preview-list">
                    <template slot="button-content">
                        <div class="nav-link count-indicator dropdown-toggle">
                            <i class="ti-bell mx-0 d-none"></i>
                            <span class="count d-none"></span>
                        </div>
                    </template>
                    <h6 class="p-3 mb-0">Notifications</h6>
                    <b-dropdown-item class="preview-item">
                        <div class="preview-thumbnail">
                            <div class="preview-icon bg-success">
                                <i class="ti-info-alt mx-0"></i>
                            </div>
                        </div>
                        <div class="preview-item-content">
                            <h6 class="preview-subject font-weight-normal">Application Error</h6>
                            <p class="font-weight-light small-text mb-0 text-muted">Just now</p>
                        </div>
                    </b-dropdown-item>
                    <b-dropdown-item class="preview-item">
                        <div class="preview-thumbnail">
                            <div class="preview-icon bg-warning">
                                <i class="ti-settings mx-0"></i>
                            </div>
                        </div>
                        <div class="preview-item-content">
                            <h6 class="preview-subject font-weight-normal">Settings</h6>
                            <p class="font-weight-light small-text mb-0 text-muted">Private message</p>
                        </div>
                    </b-dropdown-item>
                    <b-dropdown-item class="preview-item">
                        <div class="preview-thumbnail">
                            <div class="preview-icon bg-info">
                                <i class="ti-user mx-0"></i>
                            </div>
                        </div>
                        <div class="preview-item-content">
                            <h6 class="preview-subject font-weight-normal">New user registration</h6>
                            <p class="font-weight-light small-text mb-0 text-muted">2 days ago</p>
                        </div>
                    </b-dropdown-item>
                </b-nav-item-dropdown>
                <b-nav-item-dropdown right class="nav-profile">
                    <template slot="button-content">
                        <span class="nav-link dropdown-toggle" id="profileDropdown" href="javascript:void(0);"
                            data-toggle="dropdown" aria-expanded="false">
                            <div class="nav-profile-img">
<img :src="`${url}images/profile/${Image}`" alt="image">
                            </div>
                        </span>
                    </template>
                    <b-dropdown-item class="preview-item">
                        <router-link :to="{ name: 'settings' }">
                            <i class="ti-settings text-primary"></i> Settings
                        </router-link>
                    </b-dropdown-item>
                    <b-dropdown-item class="preview-item" @click="logout()">
                        <i class="ti-power-off text-primary"></i> Logout
                    </b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>
            <button class="navbar-toggler navbar-toggler-right align-self-center" type="button"
                @click="toggleMobileSidebar()">
                <span class="mdi mdi-menu"></span>
            </button>
        </div>
    </b-navbar>
</template>

<script>
import router from "../../router"
import API from '@/api'

export default {
    name: "app-header",
    data() {
        return {
            clientSettings: [],
            name: '',
            url: '',             
      Image:"",
 FirstName:''

        };
    },
    methods: {
        getAuthUser() {
            API.getAuthUser(
                '', data => {
                    this.url = data.image; 
                          this.Image = data.Image;
                      this.FirstName = data.FirstName;
                    // console.log(' this.url23 :',  this.url);
                  
                }
            )
        },
        toggleSidebar: () => {
            document.querySelector("body").classList.toggle("sidebar-icon-only");
        },
        toggleMobileSidebar: () => {
            document.querySelector("#sidebar").classList.toggle("active");
        },
        togglesettingsPannel: () => {
            document.querySelector("#right-sidebar").classList.toggle("open");
        },
        logout() {
            var admin_user = JSON.parse(localStorage.getItem('user'));
            var citizen_user = JSON.parse(localStorage.getItem('spotterClientSettings'));
            if (citizen_user) {
                if (citizen_user['user_id'] === admin_user['id']) {
                    this.$session.clear();
                    localStorage.removeItem('userPermissions');
                    localStorage.removeItem('isLoggedin');
                    localStorage.removeItem('email');
                    localStorage.removeItem('password');
                    router.push({name:"login"});
                } else {
                    API.logout(
                        data => {
                            this.$session.clear();
                            localStorage.removeItem('userPermissions');
                            localStorage.removeItem('isLoggedin');
                            localStorage.removeItem('email');
                            localStorage.removeItem('password');
                            router.push({name:"login"});
                        },
                        err => {
                        }
                    )
                }
            } else {
                API.logout(
                    data => {
                        this.$session.clear();
                        localStorage.removeItem('userPermissions');
                        localStorage.removeItem('isLoggedin');
                        localStorage.removeItem('email');
                        localStorage.removeItem('password');
                        router.push({name:"login"});
                    },
                    err => {
                    }
                )
            }
        },
        getClientSettings() {
            this.clientSettings = JSON.parse(localStorage.getItem('client_settings'));
            if (this.clientSettings) {
                this.name = this.clientSettings.name;
            }
        },

    },
    beforeMount() {

        this.getClientSettings();
        this.getAuthUser();

    },
};
</script>
